import { AuthContext } from '@/js/shared/context/AuthContext';
import { IEvent, IEventBookingTime } from '@/types/event';
import { Box, Button, Grid, Icon, IconButton } from '@material-ui/core';

import { makeStyles, Theme } from '@material-ui/core/styles';
import axios from 'axios';
import clsx from 'clsx';
import React, { useContext, useEffect, useState } from 'react';
import { EntityBookingVisitor } from './EntityBookingVisitor';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    // padding: theme.spacing(1),

    display: 'flex',
  },
  holder: {
    flex: 1,
    borderRadius: 5,
    backgroundColor: theme.palette.background.shadedown_10,
    padding: theme.spacing(1),
  },
  time: {
    display: 'flex',
    alignItems: 'center',
  },
  timeText: {
    paddingRight: 4,
  },
  selected: {
    borderColor: theme.palette.primary.main,
    borderWidth: 2,
    borderStyle: 'solid',
  },
  full: {
    textDecoration: 'line-through',
  },
}));

export const EntityBooking = ({
  event,
  entityId,
  bookingTime,
  reloadBookings,
  iHaveBooked,
  hasAdminAccess,
  gridSize = 4,
}: {
  event: IEvent;
  entityId: string;
  bookingTime: IEventBookingTime;
  reloadBookings: () => void;
  iHaveBooked: boolean;
  hasAdminAccess: boolean;
  gridSize?: number;
}) => {
  const classes = useStyles();
  const { authState } = useContext(AuthContext);
  const [error, setError] = useState<string>('');
  const iHaveBookedThis = bookingTime.visitors.find(
    (v) => v.id === authState.user.id
  );
  const full = bookingTime.visitors.length >= event.booking_settings.seats;
  useEffect(() => {
    setError('');
  }, [entityId]);
  const book = () => {
    axios
      .post(`/api/visitor/entities/${entityId}/bookings`, {
        eventBookingTimeId: bookingTime.id,
      })
      .then((res) => {
        reloadBookings();
        setError('');
      })
      .catch((err) => {
        console.log(err.response.data);
        if (err.response.data.type === 'youhavebooked') {
          setError(window.LANG.BOOK_YOUR_BUZY);
        } else if (err.response.data.type === 'full') {
          setError(window.LANG.BOOK_BUZY);
        }
      });
  };
  const cancel = () => {
    try {
      const myBookingId = bookingTime.visitors.find(
        (v) => v.id === authState.user.id
      ).id;
      axios
        .put(`/api/visitor/entities/${entityId}/cancelbookings`, {
          eventBookingTimeId: bookingTime.id,
        })
        .then((res) => {
          console.log(res.data);
          reloadBookings();
        });
    } catch (error) {
      console.log(error.response.data);
    }
  };

  return (
    <Grid item xs={12} md={gridSize} className={classes.root}>
      <div
        className={clsx(classes.holder, {
          [classes.selected]: iHaveBookedThis,
        })}
      >
        <div className={classes.time}>
          <div
            className={clsx(classes.timeText, {
              [classes.full]: (full || iHaveBooked) && !iHaveBookedThis,
            })}
          >
            {bookingTime.start_time.substring(0, 5)}
          </div>
          <div>
            {iHaveBookedThis ? (
              <IconButton color="secondary" size="small" onClick={cancel}>
                <Icon>delete</Icon>
              </IconButton>
            ) : (
              <Button
                startIcon={<Icon>handshake</Icon>}
                color="primary"
                size="small"
                onClick={book}
                disabled={full || iHaveBooked}
              >
                {event.booking_settings?.button || 'book'}
              </Button>
            )}
          </div>
        </div>
        {error && <Box color="error.main">{error}</Box>}
        {iHaveBookedThis ? (
          <div>
            <EntityBookingVisitor
              visitor={authState.user}
              hasAdminAccess={false}
            />
          </div>
        ) : hasAdminAccess && bookingTime.visitors.length > 0 ? (
          <div>
            {bookingTime.visitors.map((v) => (
              <EntityBookingVisitor
                key={v.id}
                visitor={v}
                hasAdminAccess={hasAdminAccess}
              />
            ))}
          </div>
        ) : null}
      </div>
    </Grid>
  );
};
EntityBooking.displayName = 'EntityBooking';
